<div class="portfolio-staking-sold-out-description">
	{{ "portfolio_cross_selling_staking_sold_out_content" | translate }}
</div>
